document.addEventListener('DOMContentLoaded', () => {
  const headerCart = document.querySelector('#cart-icon-bubble');
  const cartModal = document.getElementById('cart-modal');

  if (!headerCart || !cartModal) return;

  function animateCartProgressBar() {
    const bar = cartModal.querySelector('.cart-progress-track');
    if (!bar) return;

    bar.style.transition = 'none';
    bar.style.width = '0%';
    bar.offsetHeight;

    bar.style.transition = 'width 1.2s cubic-bezier(0.4, 0, 0.2, 1)';
    requestAnimationFrame(() => {
      bar.style.width = '100%';
    });
  }

  headerCart.addEventListener('click', (e) => {
    e.preventDefault();
    if (typeof window.showCartPopup === 'function') {
      window.showCartPopup();
    }
  });

  const obs = new MutationObserver(() => {
    if (cartModal.classList.contains('active')) {
      animateCartProgressBar();
    }
  });

  obs.observe(cartModal, { attributes: true, attributeFilter: ['class'] });
});
